import { render, staticRenderFns } from "./ExpeditionList.vue?vue&type=template&id=58adae18&"
import script from "./ExpeditionList.vue?vue&type=script&lang=js&"
export * from "./ExpeditionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports